import icons from '../../img/icons.svg';
import view from './view';

class searchResults extends view {
  _parentElement = document.querySelector('.results');
  _data;
  _errorMessage = '<p>No recipes found!</p>';
  _message = '<p>Start by searching for a recipe or an ingredient!</p>';

  //it will just copy the genrate markup method from its parent which view class

  // _generateMarkup() {
  //   const id = window.location.hash.slice(1);
  //   return `
  //   ${this._data
  //     .map(rec => {
  //       return `
  //       <li class="preview">
  //           <a class="preview__link ${
  //             id === rec.id ? 'preview__link--active' : ''
  //           }" href="#${rec.id}">
  //             <figure class="preview__fig">
  //               <img src="${rec.image}" alt="Test" />
  //             </figure>
  //             <div class="preview__data">
  //               <h4 class="preview__title">${rec.title}</h4>
  //               <p class="preview__publisher">${rec.publisher}</p>
  //             </div>
  //           </a>
  //         </li>`;
  //     })
  //     .join('')}
  //   `;
  // }
}

export default new searchResults();
